module.exports = __webpack_public_path__ + "media/images/welcome_banner-35d86933be61e8cb32c13d9e3fa0f136.svg";